// utils/theme.js
export const ThemeManager = {
  // 默认主题（Jdd）
  DEFAULT_THEME: 'themeJdd',

  // 初始化主题（页面加载时执行）
  // 不再从 localStorage 读取，每次都使用默认主题，由各平台页面自行设置
  init() {
    document.documentElement.setAttribute('data-theme', this.DEFAULT_THEME);
  },

  // 切换主题（Tabbar 点击时调用）
  switchTheme(themeName) {
    document.documentElement.setAttribute('data-theme', themeName);
    // 不再保存到 localStorage，主题完全由当前平台决定
  },

  // 获取当前主题
  getCurrentTheme() {
    return document.documentElement.getAttribute('data-theme') || this.DEFAULT_THEME;
  }
};
